import { render, staticRenderFns } from "./FlatButton.vue?vue&type=template&id=528844c8&scoped=true"
import script from "./FlatButton.vue?vue&type=script&lang=js"
export * from "./FlatButton.vue?vue&type=script&lang=js"
import style0 from "./FlatButton.vue?vue&type=style&index=0&id=528844c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528844c8",
  null
  
)

export default component.exports